/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiNationscodeV1Id } from '../fn/nations-code/delete-api-nationscode-v-1-id';
import { DeleteApiNationscodeV1Id$Params } from '../fn/nations-code/delete-api-nationscode-v-1-id';
import { getApiNationscodeV1$Json } from '../fn/nations-code/get-api-nationscode-v-1-json';
import { GetApiNationscodeV1$Json$Params } from '../fn/nations-code/get-api-nationscode-v-1-json';
import { getApiNationscodeV1$Plain } from '../fn/nations-code/get-api-nationscode-v-1-plain';
import { GetApiNationscodeV1$Plain$Params } from '../fn/nations-code/get-api-nationscode-v-1-plain';
import { getApiNationscodeV1Id$Json } from '../fn/nations-code/get-api-nationscode-v-1-id-json';
import { GetApiNationscodeV1Id$Json$Params } from '../fn/nations-code/get-api-nationscode-v-1-id-json';
import { getApiNationscodeV1Id$Plain } from '../fn/nations-code/get-api-nationscode-v-1-id-plain';
import { GetApiNationscodeV1Id$Plain$Params } from '../fn/nations-code/get-api-nationscode-v-1-id-plain';
import { NationsCodeModel } from '../models/nations-code-model';
import { postApiNationscodeV1$Json } from '../fn/nations-code/post-api-nationscode-v-1-json';
import { PostApiNationscodeV1$Json$Params } from '../fn/nations-code/post-api-nationscode-v-1-json';
import { postApiNationscodeV1$Plain } from '../fn/nations-code/post-api-nationscode-v-1-plain';
import { PostApiNationscodeV1$Plain$Params } from '../fn/nations-code/post-api-nationscode-v-1-plain';
import { postApiNationscodeV1Create$Json } from '../fn/nations-code/post-api-nationscode-v-1-create-json';
import { PostApiNationscodeV1Create$Json$Params } from '../fn/nations-code/post-api-nationscode-v-1-create-json';
import { postApiNationscodeV1Create$Plain } from '../fn/nations-code/post-api-nationscode-v-1-create-plain';
import { PostApiNationscodeV1Create$Plain$Params } from '../fn/nations-code/post-api-nationscode-v-1-create-plain';
import { putApiNationscodeV1Id$Json } from '../fn/nations-code/put-api-nationscode-v-1-id-json';
import { PutApiNationscodeV1Id$Json$Params } from '../fn/nations-code/put-api-nationscode-v-1-id-json';
import { putApiNationscodeV1Id$Plain } from '../fn/nations-code/put-api-nationscode-v-1-id-plain';
import { PutApiNationscodeV1Id$Plain$Params } from '../fn/nations-code/put-api-nationscode-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class NationsCodeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiNationscodeV1()` */
  static readonly GetApiNationscodeV1Path = '/private/v1/nations';

  /**
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiNationscodeV1$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1$Plain$Response(params?: GetApiNationscodeV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return getApiNationscodeV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiNationscodeV1$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1$Plain(params?: GetApiNationscodeV1$Plain$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.getApiNationscodeV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /**
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiNationscodeV1$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1$Json$Response(params?: GetApiNationscodeV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return getApiNationscodeV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * Retrieves the list of all available Nations code entities (parameter).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiNationscodeV1$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1$Json(params?: GetApiNationscodeV1$Json$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.getApiNationscodeV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /** Path part for operation `postApiNationscodeV1()` */
  static readonly PostApiNationscodeV1Path = '/private/v1/nations';

  /**
   * Retrieves the list of all available Nations code entities.
   *
   * Retrieves the list of all available Nations code entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiNationscodeV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1$Plain$Response(params?: PostApiNationscodeV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return postApiNationscodeV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available Nations code entities.
   *
   * Retrieves the list of all available Nations code entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiNationscodeV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1$Plain(params?: PostApiNationscodeV1$Plain$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.postApiNationscodeV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /**
   * Retrieves the list of all available Nations code entities.
   *
   * Retrieves the list of all available Nations code entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiNationscodeV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1$Json$Response(params?: PostApiNationscodeV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return postApiNationscodeV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available Nations code entities.
   *
   * Retrieves the list of all available Nations code entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiNationscodeV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1$Json(params?: PostApiNationscodeV1$Json$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.postApiNationscodeV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /** Path part for operation `getApiNationscodeV1Id()` */
  static readonly GetApiNationscodeV1IdPath = '/private/v1/nations/{id}';

  /**
   * Retrieves a Nation by ID.
   *
   * Retrieves a Nation by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiNationscodeV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1Id$Plain$Response(params: GetApiNationscodeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return getApiNationscodeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Nation by ID.
   *
   * Retrieves a Nation by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiNationscodeV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1Id$Plain(params: GetApiNationscodeV1Id$Plain$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.getApiNationscodeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /**
   * Retrieves a Nation by ID.
   *
   * Retrieves a Nation by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiNationscodeV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1Id$Json$Response(params: GetApiNationscodeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return getApiNationscodeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Nation by ID.
   *
   * Retrieves a Nation by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiNationscodeV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiNationscodeV1Id$Json(params: GetApiNationscodeV1Id$Json$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.getApiNationscodeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /** Path part for operation `putApiNationscodeV1Id()` */
  static readonly PutApiNationscodeV1IdPath = '/private/v1/nations/{id}';

  /**
   * Updates an existing Nation Code by ID.
   *
   * Updates an existing Nation Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiNationscodeV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiNationscodeV1Id$Plain$Response(params: PutApiNationscodeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return putApiNationscodeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Nation Code by ID.
   *
   * Updates an existing Nation Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiNationscodeV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiNationscodeV1Id$Plain(params: PutApiNationscodeV1Id$Plain$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.putApiNationscodeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /**
   * Updates an existing Nation Code by ID.
   *
   * Updates an existing Nation Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiNationscodeV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiNationscodeV1Id$Json$Response(params: PutApiNationscodeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NationsCodeModel>>> {
    return putApiNationscodeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Nation Code by ID.
   *
   * Updates an existing Nation Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiNationscodeV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiNationscodeV1Id$Json(params: PutApiNationscodeV1Id$Json$Params, context?: HttpContext): Observable<Array<NationsCodeModel>> {
    return this.putApiNationscodeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NationsCodeModel>>): Array<NationsCodeModel> => r.body)
    );
  }

  /** Path part for operation `deleteApiNationscodeV1Id()` */
  static readonly DeleteApiNationscodeV1IdPath = '/private/v1/nations/{id}';

  /**
   * Deletes a Nation by ID.
   *
   * Deletes a Nation by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiNationscodeV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiNationscodeV1Id$Response(params: DeleteApiNationscodeV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiNationscodeV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Nation by ID.
   *
   * Deletes a Nation by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiNationscodeV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiNationscodeV1Id(params: DeleteApiNationscodeV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiNationscodeV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiNationscodeV1Create()` */
  static readonly PostApiNationscodeV1CreatePath = '/private/v1/nations/Create';

  /**
   * Creates a new nation.
   *
   * Creates a new nation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiNationscodeV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1Create$Plain$Response(params?: PostApiNationscodeV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<NationsCodeModel>> {
    return postApiNationscodeV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new nation.
   *
   * Creates a new nation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiNationscodeV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1Create$Plain(params?: PostApiNationscodeV1Create$Plain$Params, context?: HttpContext): Observable<NationsCodeModel> {
    return this.postApiNationscodeV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<NationsCodeModel>): NationsCodeModel => r.body)
    );
  }

  /**
   * Creates a new nation.
   *
   * Creates a new nation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiNationscodeV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1Create$Json$Response(params?: PostApiNationscodeV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<NationsCodeModel>> {
    return postApiNationscodeV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new nation.
   *
   * Creates a new nation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiNationscodeV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiNationscodeV1Create$Json(params?: PostApiNationscodeV1Create$Json$Params, context?: HttpContext): Observable<NationsCodeModel> {
    return this.postApiNationscodeV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<NationsCodeModel>): NationsCodeModel => r.body)
    );
  }

}
